import {
	FormControlLabel,
	FormGroup,
	makeStyles,
	Switch,
	Tab,
	Tabs,
	TextField,
	withStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import './Lawyer.css';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng,
} from 'react-places-autocomplete';

function Lawyer({
	lawyerDetails,
	setLawyerDetails,
	isCompleted,
	setIsCompleted,
	setDisable,
	disable,
}) {
	const [value, setValue] = useState(1);
	const [address, setAddress] = useState(
		lawyerDetails?.address ? lawyerDetails?.address : ''
	);

	const [formData, setFormData] = useState({
		companyName: lawyerDetails?.companyName
			? lawyerDetails?.companyName
			: '',
		lawyerName: lawyerDetails?.lawyerName ? lawyerDetails?.lawyerName : '',
		phoneNumber: lawyerDetails?.phoneNumber
			? lawyerDetails?.phoneNumber
			: '',
		email: lawyerDetails?.email ? lawyerDetails?.email : '',
	});

	const { companyName, lawyerName, phoneNumber, email } = formData;

	useEffect(() => {
		console.log('setLawyerDetails', setLawyerDetails);
		if (value === 1) {
			setDisable({ ...disable, lawyer: false });
			setLawyerDetails();
		}
	}, [value]);

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			width: '41em',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
		},
		lawyerTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '22em',
			borderRadius: '8px',
		},
	}));

	const handleChange = (event, newValue) => {
		if (newValue === 1) {
			setLawyerDetails();
			setDisable({ ...disable, lawyer: false });
		} else if (newValue === 0) {
			setIsCompleted({ ...isCompleted, lawyer: false });
			setDisable({ ...disable, lawyer: true });
		}
		setValue(newValue);
	};

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',
			borderRadius: '8px',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	// const handleChange = (event) => {
	// 	setIsChecked({ ...isChecked, [event.target.name]: event.target.checked });
	// };

	const handleSave = () => {
		setDisable({ ...disable, lawyer: false });
		setLawyerDetails({
			companyName: companyName,
			lawyerName: lawyerName,
			phoneNumber: phoneNumber,
			address: address,
			email: email,
		});
	};

	const handleSelect = async (value) => {
		const results = await geocodeByAddress(value);
		setAddress(value);
	};

	return (
		<div className='doc_card lawyer_wrapper'>
			<div className='card_title'>Does the client have a lawyer?</div>
			<div className={styles.lawyerTab}>
				<div className={styles.clientTab}>
					<StyledTabs value={value} onChange={handleChange} centered>
						<StyledTab label={'Yes'} />
						<StyledTab label={'No'} />
					</StyledTabs>
				</div>
			</div>
			{/* <FormGroup>
				<FormControlLabel
					control={
						<LawyerSwitch
							checked={isChecked.lawyer}
							onChange={handleChange}
							name='lawyer'
						/>
					}
				/>
			</FormGroup> */}
			<div className={styles.root}>
				{value === 0 ? (
					<div className='lawyer_form'>
						<div className={styles.form}>
							<TextField
								type='text'
								label='Company Name'
								name='companyName'
								value={companyName}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>
							<TextField
								type='text'
								label='Lawyer'
								name='lawyerName'
								value={lawyerName}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>

							<TextField
								type='tel'
								label='Phone Number'
								className={styles.field}
								pattern='[0-9]{3}[0-9]{3}[0-9]{4}'
								name='phoneNumber'
								value={phoneNumber}
								onChange={(e) => onChange(e)}
							/>
							{/* <TextField
								type='text'
								label='Address'
								name='address'
								value={address}
								className={styles.field}
								onChange={(e) => onChange(e)}
							/> */}

							<PlacesAutocomplete
								value={address}
								onChange={setAddress}
								onSelect={handleSelect}
								className={styles.field}
							>
								{({
									getInputProps,
									suggestions,
									getSuggestionItemProps,
									loading,
								}) => (
									<div className={styles.field}>
										<TextField
											style={{ width: '100%' }}
											{...getInputProps({
												placeholder: 'Address',
												className:
													'location-search-input',
											})}
										/>

										<div className='autocomplete-dropdown-container'>
											{loading && <div>Loading...</div>}
											{suggestions.map((suggestion) => {
												const className =
													suggestion.active
														? 'suggestion-item--active'
														: 'suggestion-item';
												// inline style for demonstration purpose
												const style = suggestion.active
													? {
															backgroundColor:
																'#fafafa',
															cursor: 'pointer',
													  }
													: {
															backgroundColor:
																'#ffffff',
															cursor: 'pointer',
													  };
												return (
													<div
														{...getSuggestionItemProps(
															suggestion,
															{
																className,
																style,
															}
														)}
													>
														<span>
															{
																suggestion.description
															}
														</span>
													</div>
												);
											})}
										</div>
									</div>
								)}
							</PlacesAutocomplete>
							<TextField
								type='email'
								label='Email Address'
								name='email'
								value={email}
								autoComplete='false'
								className={styles.field}
								onChange={(e) => onChange(e)}
							/>
						</div>
						<button
							className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
							onClick={() => handleSave()}
						>
							Save
						</button>
					</div>
				) : null}
			</div>
		</div>
	);
}

export default Lawyer;
